<template>
  <div id="quote">
    <div class="container">
      <div class="quotation">“</div>
      <span v-once v-if="diff">
        已来 AnyTeach {{ diff }} 天，{{
        phrases[Math.floor(Math.random() * phrases.length)]
        }}
      </span>
      <router-link tag="span" to="/courses" v-else>
        欢迎来到 AnyTeach，
        <span class="red">看看课程吧</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Quote",
  data() {
    return {
      phrases: [
        "继续磨耳朵 👂",
        "加把劲 💪",
        "不错哦 😊",
        "贵在坚持 📖",
        "你是最棒的 🏆",
        "胜利属于你 🥇",
        "好勤奋呀 📚",
        "坚持就是胜利 ✌️",
        "keep it up 🏃",
      ],
    }
  },
  computed: {
    diff() {
      if (!this.$store.state.user.create_time) {
        return 0
      }
      const today = this.$moment(new Date())
      const create_time = this.$moment(this.$store.state.user.create_time)
      const diff = today.diff(create_time, "days")
      return diff + 1
    },
  },
}
</script>

<style scoped lang="scss">
// @import "../../../static/css/public.scss";

#quote {
  width: 90%;
  margin: 0 5% 20px 5%;
}
.container {
  @include avenir();
  background: #f9f9f9;
  border-radius: 3px;
  border: 1px solid #eee;
  padding: 15px 10px;
  margin: 0 auto 15px auto;
  text-align: center;
  width: 100%;
  span {
    font-weight: 500;
    font-size: 1rem;
  }
  .quotation {
    font-size: 2.5rem;
    color: $black;
    font-family: sans-serif;
    margin: 0 0 -20px 0;
    line-height: 1;
  }
}
</style>
